const initListeFluxRss = [
    {
        nom: "l'Équipe",
        url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg",
        listFlux: [
            {
                 titre:"Flux général de l'Équipe"
                ,url:"https://www.lequipe.fr/rss/actu_rss.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Football"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Football.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Mercato du football"
                ,url:"https://www6.lequipe.fr/rss/actu_rss_Transferts.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Tennis"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Tennis.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Rugby"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Rugby.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Cyclisme"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Cyclisme.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Basket "
                ,url:"https://www.lequipe.fr/rss/actu_rss_Basket.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - NBA"
                ,url:"https://www.lequipe.fr/rss/actu_rss_NBA.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Sports auto"
                ,url:"https://www6.lequipe.fr/rss/actu_rss_Auto-Moto.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - F1"
                ,url:"https://www6.lequipe.fr/rss/actu_rss_F1.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Rallye"
                ,url:"https://www6.lequipe.fr/rss/actu_rss_Rallye.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Judo"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Judo.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Moto"
                ,url:"https://www6.lequipe.fr/rss/actu_rss_Moto.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Handball"
                ,url:"https://www6.lequipe.fr/rss/actu_rss_Hand.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Volley"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Volley.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Ski"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Ski.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Golf"
                ,url:"https://www6.lequipe.fr/rss/actu_rss_Golf.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Athlétisme"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Athletisme.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Natation"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Natation.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Voile"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Voile.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - Escrime"
                ,url:"https://www.lequipe.fr/rss/actu_rss_Escrime.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
            {
                titre:"l'Équipe - eSport"
                ,url:"https://www.lequipe.fr/rss/actu_rss_esport.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/41/Photo-le-logo-de-l-equipe.jpg"
            },
        ],
        description: ''
    }, {
        nom: "BFM",
        url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png",
        listFlux: [
            {
                titre:"BFMTV - Toute l'actualité"
                ,url:"https://www.bfmtv.com/rss/news-24-7/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Santé"
                ,url:"https://www.bfmtv.com/rss/sante/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Auto"
                ,url:"https://www.bfmtv.com/rss/auto/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Culture"
                ,url:"https://www.bfmtv.com/rss/culture/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - International"
                ,url:"https://www.bfmtv.com/rss/international/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Politique"
                ,url:"https://www.bfmtv.com/rss/politique/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Sciences"
                ,url:"https://www.bfmtv.com/rss/sciences/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Environnement"
                ,url:"https://www.bfmtv.com/rss/environnement/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Environnement - Climat"
                ,url:"https://www.bfmtv.com/rss/environnement/climat/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Police-justice"
                ,url:"https://www.bfmtv.com/rss/police-justice/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Société"
                ,url:"https://www.bfmtv.com/rss/societe/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Voyage"
                ,url:"https://www.bfmtv.com/rss/voyage/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Animaux"
                ,url:"https://www.bfmtv.com/rss/animaux/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
            {
                titre:"BFMTV - Cuisine"
                ,url:"https://www.bfmtv.com/rss/cuisine/"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Logo_BFM_TV_%282019%29.png"
            },
        ],
        description: ''
    },
    // {
    //     nom: "Le Monde",
    //     url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg",
    //     listFlux: [
    //         {
    //             titre:"Le Monde - Actualités"
    //             ,url:"https://www.lemonde.fr/rss/une.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //         {
    //             titre:"Le Monde - International "
    //             ,url:"https://www.lemonde.fr/international/rss_full.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //         {
    //             titre:"Le Monde - Economie "
    //             ,url:"https://www.lemonde.fr/economie/rss_full.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //         {
    //             titre:"Le Monde - Culture "
    //             ,url:"https://www.lemonde.fr/culture/rss_full.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //         {
    //             titre:"Le Monde - Sport "
    //             ,url:"https://www.lemonde.fr/sport/rss_full.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //         {
    //             titre:"Le Monde - Planète "
    //             ,url:"https://www.lemonde.fr/planete/rss_full.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //         {
    //             titre:"Le Monde - Pixels "
    //             ,url:"https://www.lemonde.fr/pixels/rss_full.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //         {
    //             titre:"Le Monde - Sciences"
    //             ,url:"https://www.lemonde.fr/sciences/rss_full.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //         {
    //             titre:"Le Monde - Opinions"
    //             ,url:"https://www.lemonde.fr/idees/rss_full.xml"
    //             ,url_img: "https://upload.wikimedia.org/wikipedia/commons/4/43/Le_Monde.svg"
    //         },
    //     ],
    //     description: ''
    // },
    {
        nom: "Le Parisien",
        url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png",
        listFlux: [
            {
                titre:"Le Parisien - Faits divers"
                ,url:"https://feeds.leparisien.fr/leparisien/rss/faits-divers"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
            {
                titre:"Le Parisien - Politique "
                ,url:"https://feeds.leparisien.fr/leparisien/rss/politique"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
            {
                titre:"Le Parisien - Economie "
                ,url:"https://feeds.leparisien.fr/leparisien/rss/economie"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
            {
                titre:"Le Parisien - International "
                ,url:"https://feeds.leparisien.fr/leparisien/rss/international"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
            {
                titre:"Le Parisien - Sports "
                ,url:"https://feeds.leparisien.fr/leparisien/rss/sports"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
            {
                titre:"Le Parisien - Culture Loisirs"
                ,url:"https://feeds.leparisien.fr/leparisien/rss/culture-loisirs"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
            {
                titre:"Le Parisien - Société "
                ,url:"https://feeds.leparisien.fr/leparisien/rss/societe"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
            {
                titre:"Le Parisien - Immobilier "
                ,url:"https://feeds.leparisien.fr/leparisien/rss/immobilier"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
            {
                titre:"Le Parisien - Environnement"
                ,url:"https://feeds.leparisien.fr/leparisien/rss/environnement"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Le_Parisien_-_logo_2016.png"
            },
        ],
        description: ''
    }, {
        nom: "Europe 1",
        url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png",
        listFlux: [
            {
                titre:"Europe 1 - Actualités"
                ,url:"https://www.europe1.fr/rss.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Sport"
                ,url:"https://www.europe1.fr/rss/sport.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Politique"
                ,url:"https://www.europe1.fr/rss/politique.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - International"
                ,url:"https://www.europe1.fr/rss/international.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Technologies"
                ,url:"https://www.europe1.fr/rss/technologies.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Faits divers"
                ,url:"https://www.europe1.fr/rss/faits-divers.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Santé"
                ,url:"https://www.europe1.fr/rss/sante.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Économie"
                ,url:"https://www.europe1.fr/rss/economie.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Culture"
                ,url:"https://www.europe1.fr/rss/culture.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Société"
                ,url:"https://www.europe1.fr/rss/societe.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            {
                titre:"Europe 1 - Sciences"
                ,url:"https://www.europe1.fr/rss/sciences.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
            // {
            //     titre:"Europe 1 - Humour"
            //     ,url:"https://www.europe1.fr/rss/humour.xml"
            //     ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            // },
            {
                titre:"Europe 1 - Insolite"
                ,url:"https://www.europe1.fr/rss/insolite.xml"
                ,url_img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Europe_1_logo_%282010%29.svg/langfr-1280px-Europe_1_logo_%282010%29.svg.png"
            },
        ],
        description: ''
    }, {
        nom: "France 24",
        url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png",
        listFlux: [
            {
                titre:"France 24 - Monde"
                ,url:"https://www.france24.com/fr/rss"
                ,url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png"
            },
            {
                titre:"France 24 - Europe"
                ,url:"https://www.france24.com/fr/europe/rss"
                ,url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png"
            },
            {
                titre:"France 24 - France"
                ,url:"https://www.france24.com/fr/france/rss"
                ,url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png"
            },
            {
                titre:"France 24 - Économie"
                ,url:"https://www.france24.com/fr/economie/rss"
                ,url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png"
            },
            {
                titre:"France 24 - Sports"
                ,url:"https://www.france24.com/fr/sports/rss"
                ,url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png"
            },
            {
                titre:"France 24 - Culture"
                ,url:"https://www.france24.com/fr/culture/rss"
                ,url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png"
            },
            {
                titre:"France 24 - Planète"
                ,url:"https://www.france24.com/fr/planete/rss"
                ,url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png"
            },
            {
                titre:"France 24 - Découvertes"
                ,url:"https://www.france24.com/fr/decouvertes/rss"
                ,url_img: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/Logos_FRANCE24_RVB_2013.svg/langfr-1024px-Logos_FRANCE24_RVB_2013.svg.png"
            },
        ],
        description: ''
    }
];

export const listeExempleFluxRss = initListeFluxRss.sort(function (a, b) {
    if ( a.nom < b.nom ){
        return -1;
    }
    if ( a.nom > b.nom ){
        return 1;
    }
    return 0;
});